module.exports = {"532531101":"大兴镇","532531102":"牛孔镇","532531103":"大黑山镇","532531104":"平河镇","532531201":"戈奎乡","532531203":"大水沟乡","532531205":"半坡乡","532531206":"骑马坝乡","532531207":"三猛乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532531.json
// module id = 2444
// module chunks = 0